module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_activities04-dc203c8d82a3dc86648a3f870c8cb1bd.jpg";